import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { CustomerPortalAppSettings } from "../settings";

function getFeatureFlagOverride(
  featureFlag: FeatureFlagKey,
): boolean | undefined {
  try {
    const override = localStorage?.getItem(`override-${featureFlag}`);
    if (!override || (override !== "false" && override !== "true")) {
      return undefined;
    }
    return override === "true";
  } catch (error) {
    return undefined;
  }
}

export function getReturnFlowABTestValues(
  settings: CustomerPortalAppSettings | undefined,
  featureFlags: Record<FeatureFlagKey, boolean> | undefined | null,
) {
  if (settings?.exchangeAgentSettings.forceNewFlow) {
    return {
      useNewExchangeFlow: true,
      hasNewExchangeFlowFeatureFlag: false,
      continueVsExchange: false,
    };
  }

  const useNewExchangeFlow =
    getFeatureFlagOverride(FeatureFlagKey.NEW_EXCHANGE_REFUND_FLOW) ??
    !!featureFlags?.[FeatureFlagKey.NEW_EXCHANGE_REFUND_FLOW];
  const hasNewExchangeFlowFeatureFlag =
    !useNewExchangeFlow &&
    featureFlags?.[FeatureFlagKey.NEW_EXCHANGE_REFUND_FLOW] !== undefined;
  const continueVsExchange =
    getFeatureFlagOverride(FeatureFlagKey.CONTINUE_VS_EXCHANGE) ??
    !!featureFlags?.[FeatureFlagKey.CONTINUE_VS_EXCHANGE];

  return {
    useNewExchangeFlow,
    hasNewExchangeFlowFeatureFlag,
    continueVsExchange,
  };
}
